module.exports = __webpack_public_path__ + "static/img/change-never-01.1984111.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/change-never-01.jpg
// module id = 247
// module chunks = 1